/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SubscriptionDetails/Digital/theme';

export const SubscriptionDetailsDigitalTheme = theme;
